import React from "react";

import {
    Card,
    Empty,
    List,
    Tag,
    Typography
} from "antd";

import {
    DollarOutlined,
    MessageOutlined
} from "@ant-design/icons";

const {
    Text,
    Title
} = Typography;


const OfferList = ({
                       notifications = []
                   }) => {

    if (!notifications.length) {
        return (
            <Empty
                description="Aucune offre en cours"
            />
        );
    }

    return (
        <List
            dataSource={notifications}
            rowKey={notification => notification.id}
            renderItem={notification => (

                <List.Item>

                    <Card
                        style={{
                            width: "100%",
                            borderRadius: 12
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                gap: 16
                            }}
                        >

                            <div>

                                <Title
                                    level={5}
                                    style={{
                                        marginBottom: 8
                                    }}
                                >
                                    <DollarOutlined />
                                    {" "}
                                    {notification.title ||
                                        "Nouvelle offre"}
                                </Title>

                                <Text
                                    type="secondary"
                                >
                                    {notification.message}
                                </Text>

                            </div>

                            <Tag
                                color="orange"
                            >
                                PENDING
                            </Tag>

                        </div>

                        <div
                            style={{
                                marginTop: 12
                            }}
                        >

                            <Text
                                type="secondary"
                            >
                                <MessageOutlined />
                                {" "}
                                Demande associée
                            </Text>

                        </div>

                        {notification.createdAt && (
                            <div
                                style={{
                                    marginTop: 8
                                }}
                            >
                                <Text
                                    type="secondary"
                                >
                                    {new Date(
                                        notification.createdAt
                                    ).toLocaleString(
                                        "fr-FR"
                                    )}
                                </Text>
                            </div>
                        )}

                    </Card>

                </List.Item>

            )}
        />
    );
};

export default OfferList;